import { Component, ElementRef, ViewChild } from '@angular/core';
import { EditorService } from '../../md/service/editor.service';
import Swal from 'sweetalert2';
import { session } from '../../../environments/environment.session'
import { NgxSpinnerService } from 'ngx-spinner';
import { ClerkNocService } from '../service/clerk-noc.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ApprovalUserService } from '../../portal/service/approval-user.service';
import { ToastrService } from 'ngx-toastr';
import { MainService, MainService as mainserviceEmb } from '../../emb/service/main.service';
import { CommonDataService } from '../../emb/common _services/common-data.service';

import { NocHierService } from '../service/noc-hier.service';
import { LogService } from '../../portal/service/log.service';
import { AdminstrationService } from '../service/adminstration.service';
import { MainService as mainService_MD } from '../../md/service/main.service'
import { NEVER } from 'rxjs';
import { MainService as portalmainservice } from '../../portal/service/main.service';
import { json } from 'express';

import { Router } from '@angular/router';
import { AllEmpService } from '../../hrms/service/all-emp.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
// import {MainService} from '../service/main.service';
import { Mainservice2Service } from '../service/mainservice2.service';
declare var $: any

@Component({
  selector: 'app-carto-screen',
  templateUrl: './carto-screen.component.html',
  styleUrls: ['./carto-screen.component.css']
})
export class CartoScreenComponent {
 
  displayedColumns: any = ['si_no',  'file_number', 'file_desc', 'status', 'action'];
  @ViewChild('paginator1', { static: false }) paginator1!: MatPaginator;
  @ViewChild('sortCol1', { static: false }) sortCol1!: MatSort;
  datasource: any;
  ebillUser: any;
  b_acct_id: any;
  third: any;
  userObj: any = {}
  first: any;
  second: any;
  isLinear: any;
  clerk_flag: boolean = false;
  eng_Dept_flag: boolean =false;
  status: any;

  @ViewChild(MatPaginator, { static: false })
  set paginator(value: MatPaginator) {
    if (this.datasource) {
      this.datasource.paginator = value;
    }
  }
  @ViewChild(MatSort, { static: false })
  set sort(value: MatSort) {
    if (this.datasource) {
      this.datasource.sort = value;
    }
  }
  applyFilter(filterValue: string) {
    this.datasource.filter = filterValue.trim().toLowerCase();
  }
  constructor(public Mainservice2Service :Mainservice2Service,private allEmpService: AllEmpService, 
    public portalmainservice: portalmainservice, public router: Router, private mainServiceMD: mainService_MD, 
    private adminstration_S: AdminstrationService, private embHierService: NocHierService, private mainService: MainService, 
    private log: LogService,   private toastr: ToastrService, public ApprovalUserService: ApprovalUserService, 
    private editorService: EditorService, public spinner: NgxSpinnerService, public clerknocservice: ClerkNocService,public mainserviceEmb: mainserviceEmb,
  ) { }
  create_flag : boolean = false;
  NocObj : any = {};
  list_flag : boolean = false
  async ngOnInit() {
    this.ebillUser = JSON.parse(atob(session.erpUser));
    this.b_acct_id = this.ebillUser.b_acct_id;
    await this.getAllTaskOfUser();
    await this.getallworkflowuser();
  }
  allTaskArr: any = []
  allAprvlData: any = []

  async getAllTaskOfUser() {
    this.allTaskArr = []
    var obj: any = Object()
    obj['b_acct_id'] = this.ebillUser.b_acct_id
    obj['user_id'] = this.ebillUser.user_id
    obj["status"] = ['PENDING', 'APPROVED']
    obj["module_cd"] = 'NOC'

    obj["doc_type"] = ['CARTOGRAPHER']

    obj["role"] = 'CARTOGRAPHER'
    //     var resp = await this.mainService.getAllTaskOfUser(JSON.stringify(obj))

    var resp = await this.mainService.getAllTaskOfUser(JSON.stringify(obj));
    console.log(resp)

    if (resp['error'] == false) {
      this.allAprvlData = []
      this.allTaskArr = resp['data']
      this.mainService.count = this.allTaskArr.length
      let j = 1
      for (let i = 0; i < this.allTaskArr.length; i++) {
        this.allTaskArr[i]['new_index'] = j
        j = j + 1
      }


    } else {
      Swal.fire("Error", resp['data'], 'error');
    }

    let without_reject_data: any = []
    let rejcted_Data: any = []
    this.allTaskArr = this.allTaskArr.filter((item: any) => {

      if (item.life_cycle_status != 'REJECTED') {
        without_reject_data.push(item)
      } else {
        rejcted_Data.push(item)

      }
    })
    console.log(without_reject_data, rejcted_Data);
    this.datasource= new MatTableDataSource(without_reject_data)
    this.datasource.paginator = this.paginator1;
    this.datasource.sort = this.sortCol1;

  
  }

  view(element: any) {
    this.clerknocservice.file_id = element.doc_local_no !== undefined ? element.doc_local_no : element.file_id;
    this.router.navigate(['/noc-view']);
    this.clerknocservice.setData(this.router.url);
  }
  alltabledata: any = {};
  show_Data_obj: any = {};
  AllWorkFlow_Data: any = [];
  all_data_arr: any = []
  async add_to_approval(element: any) {
    await this.editorService.clearTetx()

    this.show_Data_obj = {}
    this.alltabledata = {}
    this.AllWorkFlow_Data
    let obj: any = Object.assign({}, element)
    this.alltabledata = Object.assign({}, element)
    console.log(this.alltabledata);
    console.log(this.AllWorkFlow_Data, "lllkkkkoo");
    console.log(this.role, "roleee");
    let arr = this.AllWorkFlow_Data.filter((item: any) => item.role_cd == this.role);
    console.log(arr);
    let alluperrole = []
    if (arr.length > 0) {
      const [{ level: targetLevel }] = arr;

      let secondarray = this.AllWorkFlow_Data.filter((item: any) =>
        arr.some((departmentObj: any) => departmentObj.doc_type === item.doc_type)
      );
      console.log(secondarray);

      let finalarr = secondarray.filter((item: any) => item.level <= targetLevel);
      console.log(finalarr);
      alluperrole = finalarr.map((item: any) => item.role_cd)

    } else {
      console.log("No matching role_cd found in AllWorkFlow_Data");
    }


    obj["b_acct_id"] = this.b_acct_id
    obj["role"] = ['CTP', 'CRK', ...alluperrole]
    console.log(obj);
    delete obj.forward_msg;
    obj["check"]
    let resp = await this.clerknocservice.getfiledatabyfileid(obj)
    console.log(resp)
    if (resp["error"] == false) {
      this.show_Data_obj["file_details"] = resp['file_detail'][0]
      this.show_Data_obj["file_notesheet"] = resp['file_notesheet']
      this.show_Data_obj["file_supp_doc"] = resp['file_supp_doc']
      this.show_Data_obj["party_doc"] = resp['party_doc']

      if (this.show_Data_obj["file_notesheet"].length > 0) {
        this.show_Data_obj["file_notesheet"].map((x: any) => {
          if (x && 'description' in x) {
            try {
              const parsedRemark = JSON.parse(x['description']);
              if (typeof parsedRemark === 'object' && 'body' in parsedRemark) {
                x['description'] = parsedRemark['body'];

              }
            } catch (e) {
              console.log('error')

            }
          }
        })
      }


      // console.log(this.show_Data_obj, " this.show_Data_obj")
      // console.log(this.all_data_arr, " this.all_data_arr")


      this.show_Data_obj['doc_type'] = null

      // Find the matching object in the array based on file_id
      const matchingObject = this.all_data_arr.find((item: { file_id: any; }) => item.file_id == this.show_Data_obj['file_details']['file_id']);
      console.log(matchingObject);

      // Add the doc_type to the file_details object if a match is found
      if (matchingObject) {
        this.show_Data_obj['doc_type'] = matchingObject['doc_type'];
      }
      console.log(this.show_Data_obj, " this.show_Data_obj")
      this.list_flag = true

    }
  }
  role(role: any, arg1: string) {
    throw new Error('Method not implemented.');
  }

  export(){

  }
  open_list(){
    this.list_flag = false;
  }
  added_notesheet:any=false
  async addmorenotesheet() {




    await this.editorService.clearTetx()
    this.added_notesheet=true
    $('#notesheetmodal').modal('show');

    console.log(this.show_Data_obj["file_notesheet"]);

  }
  current_noc_data: any = [];
  remark_note: any = null
  addctpnotesheet() {
    this.current_noc_data = []
    this.remark_note = this.editorService.to_data
    this.current_noc_data["description"] = JSON.parse(this.remark_note).body
    this.current_noc_data["lang"] = this.editorService.language
    console.log(this.current_noc_data);
    this.show_Data_obj["description"] = this.remark_note
    this.show_Data_obj["lang"] = this.editorService.language
    console.log(this.show_Data_obj);
    this.added_notesheet=false
    $('#notesheetmodal').modal('hide');
  }
  async uploadmoredoc() {
    $('#uploadmoredocmodal').modal('show');
    console.log(this.NocObj);

  }
  selectedFile: any = []
  selected_file_name: any = []
  upload_name_arr: any = []
  private readonly ALLOWED_TYPES = ['application/pdf', 'image/png', 'image/jpeg'];
  private readonly MAX_TOTAL_SIZE = 5 * 1024 * 1024; // 5 MB
  @ViewChild('uploaddocument', { static: false }) uploaddocument!: ElementRef;

  async addsupprotivedoc(event: any) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const files = Array.from(input.files);
      let totalSize = 0;
      const invalidFiles = files.filter(file => {
        totalSize += file.size;
        return !this.ALLOWED_TYPES.includes(file.type) || totalSize > this.MAX_TOTAL_SIZE;
      });
      let errorMessage;

      if (totalSize > this.MAX_TOTAL_SIZE) {
        errorMessage = ` Total file size exceeds the limit of 5 MB.\n`;
        Swal.fire('Info', errorMessage, 'info');
      }

      if (invalidFiles.length > 0) {
        let errorMessage = 'This is support only this type  PDF, PNG, or JPEG of file support .` ';
        invalidFiles.forEach(file => {
          if (!this.ALLOWED_TYPES.includes(file.type)) {
            errorMessage += `PDF, PNG, or JPEG of file support .`;
          }
          // if (totalSize > this.MAX_TOTAL_SIZE) {
          //   errorMessage += `- Total file size exceeds the limit of 5 MB.\n`;
          // }
        });
        Swal.fire('Info', errorMessage, 'info');
        // Optionally, you can clear the input if there are invalid files
        input.value = '';
        this.selectedFile = null
        return;
      }

      // Proceed with valid files
      // Your upload logic here
      console.log('Valid files:', files);
    }
    this.upload_name_arr = []
    this.selectedFile = []
    this.selected_file_name = []
    if (event.target.files.length == 0) {
      for (let i = 0; this.upload_name_arr.length; i++) {
        if (this.upload_name_arr[i] == this.selected_file_name) {
          this.upload_name_arr.splice(i, 1)
          break
        }
      }
      this.selectedFile = []
      this.selected_file_name = []
      return
    }
    // let resp = await this.validatePdfSize(event)
    // if (!resp) {
    //   // this.reset();
    //   this.uploadsupprotivedocument.nativeElement.value = null;
    //   return
    // }

    for (let i = 0; i < event.target.files.length; i++) {

      this.selectedFile[i] = event.target.files[i];
      this.selected_file_name[i] = event.target.files[i]['name']
    }


    if (this.upload_name_arr.includes(this.selected_file_name) == true) {
      Swal.fire('Warning...', 'Same Name Document can not be Uploaded', 'warning')
      this.uploaddocument.nativeElement.value = null;
      return;
    } else {
      this.upload_name_arr = this.selected_file_name
    }
    let file_name = [];
    if (this.selectedFile.length > 0) {
      for (let i = 0; i < this.selectedFile.length; i++) {

        file_name[i] = this.selected_file_name[i].split('.')
      }
    }
    // if (file_name.length < 2 || file_name[file_name.length - 1] != 'pdf') {
    //   this.selectedFile2 = null;
    //   // this.reset();
    //   this.uploaddocument.nativeElement.value = null;

    //   Swal.fire('Warning...', 'File Numbert Supported , Please upload pdf format file', 'warning')
    //   return;
    // }
    this.NocObj['supportive_doc'] = this.selected_file_name
    console.log(this.NocObj['supportive_doc'],"supportive document")
  }

  fileURL: any
  async view_correspondence(correspondence_no: any, file_id: any) {
    console.log(correspondence_no)
    let obj: any = {}
    obj['b_acct_id'] = this.b_acct_id
    obj['doc_name'] = correspondence_no
    obj['file_id'] = file_id
    console.log(obj);

    var res = await this.clerknocservice.viewCorrespondence(obj)

    if (res) {
      let file = new Blob([res], { type: 'application/pdf' });
      this.fileURL = URL.createObjectURL(file);
      // console.log(fileURL)
      window.open(this.fileURL)
      // PDFObject.embed(this.fileURL, '#pdf')
    } else {

    }


  }
  logObj = { component: 'CLERK REGISTRATION' }
  allSearchableEmp: any = []
  allEmplyees_new: any = []
  allEmployees: any = [];
  async getAllEmployees() {
    console.log('all emp')
    this.spinner.show();
    var arr: any = []
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['module_cd'] = 'NOC'
    var resp = await this.mainServiceMD.getuserformodulerolemapping(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "User for Module Role Mapping Received Successfully " })
      this.spinner.hide()
      arr = resp.data;
      console.log(resp, 'users')
      for (let i = 0; i < arr.length; i++) {
        this.userObj[arr[i]['user_id']] = arr[i]
        arr[i]['desc'] = arr[i]['user_id'] + " - " + arr[i]['emp_name'] + " - " + arr[i]['emp_phone_no']
      }
      this.allSearchableEmp = arr

    } else {
      this.spinner.hide()
    }
    console.log(this.allEmployees, this.allEmplyees_new, 'employees')
  }
  async submitjedata() {
    console.log(this.alltabledata)
    console.log(this.show_Data_obj['doc_type']);

    // this.salBill_apprdata = Object.assign({}, alltabledata)
    this.alltabledata['level'] = 1
    this.alltabledata['branch'] = 1
    this.alltabledata['doc_local_no'] = this.alltabledata['file_id']
    // this.alltabledata['doc_type'] = 'ENGINEERING'//this.salBill_apprdata['id']
    this.alltabledata['doc_type'] = "CARTOGRAPHER"//this.salBill_apprdata['id']

    this.alltabledata['node_cd'] = this.alltabledata['node_cd']
    this.alltabledata['module_cd'] = 'NOC';
    // this.alltabledata['node_cd'] = 1101
    console.log(this.alltabledata)

    // await this.ApprovalUserService.getWorkflowlog(this.ebillUser, 'ENGINEERING', 'NOC');
    await this.ApprovalUserService.getWorkflowlog(this.ebillUser, "CARTOGRAPHER", 'NOC');

    if (this.ApprovalUserService.workflow_level1 == undefined) {
      // await this.ChangestatusSalBill(this.salBill_apprdata['doc_local_no'], 'APPROVED')
      return;
    }
    await this.ApprovalUserService.getMostLatestWorkflowlog(this.ebillUser, this.alltabledata)
    await this.ApprovalUserService.getWorkflowloguser(this.ebillUser, this.alltabledata)
    /* await this.getAllRule();
    await this.getundertakings(element); */
    console.log(this.ApprovalUserService.workuser)
    console.log(this.ApprovalUserService.approvalflag, this.ApprovalUserService.vendorflag);

    $('#myModal3').modal('show');
  }
  forwarded_user_id: any;
  appr_remark: any
  isResponseReceived: boolean = false;
  send_to_carto:boolean = false;
  salBill_apprdata: any
  node_code: any = [];
  message_flag: any = false
  async Approvedapproval() {
    this.spinner.show()
    let d_type;
    let d_status
    if(this.send_to_carto){
      d_type = 'CARTOGRAPHER';
      d_status = 'ASSINGED_CARTOGRAPHER'
    }else{
      d_type = 'CTP'
      d_status = 'ASSINGED_CTP'
    }
    let obj: any = {}
    // if (this.clerk_flag == true) {
    //   obj['doc_type'] = d_type
    // } else if (this.eng_Dept_flag == true) {
    //   obj['doc_type'] = this.show_Data_obj['doc_type']
    // }
    obj['doc_local_no'] = this.alltabledata['file_id']
    obj['module_cd'] = 'NOC'
    obj["b_acct_id"] = this.b_acct_id
    // obj["role_cd"] = this.role
    // let status = this.status;
    let resp1 = await this.clerknocservice.getworkflowloguser(JSON.stringify(obj))
    if (resp1["error"] == false) {
      if (resp1.data.length == 0) {

        this.isResponseReceived = true
        this.spinner.show()
        this.isResponseReceived = true
        if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
          let obb: any = new Object();

          obb['user_id'] = this.ebillUser.user_id
          obb['b_acct_id'] = this.ebillUser.b_acct_id
          obb['forwarded_by'] = this.ebillUser.user_id
          obb['forward_msg'] = this.appr_remark
          obb['remark'] = this.appr_remark
          obb['status'] = 'APPROVED'
          let status;
          obb['doc_local_no'] = this.salBill_apprdata['file_id']
          obb['doc_desc'] = `${this.salBill_apprdata['party_name']} 's  File Number ${this.salBill_apprdata['file_id']} Is Assigned to ${d_type}`
          // obb['role_cd'] = this.ApprovalUserService.level1['role_cd']//this.level1['role_cd']
          obb['role_cd'] = this.role//this.level1['role_cd']

          obb['module_cd'] = 'NOC'
          obb['node_cd'] = this.node_code
          obb['level'] = this.ApprovalUserService.level1['level']
          obb['undertaking'] = JSON.stringify([])
          obb['branch'] = this.ApprovalUserService.level1['branch']
          obb['user_name'] = this.ebillUser.party_name;
          obb['field_value'] = 0



          let resp = await this.mainserviceEmb.insertTask(obb)
          if (resp['error'] == false) {
            await this.pendingapproval()
            if (this.clerk_flag == true) {


              await this.ChangeStatus(this.salBill_apprdata['file_id'], status, obb)
            } else if (this.eng_Dept_flag == true) {

              await this.changedeptstatus(this.salBill_apprdata['file_id'], status, obb)

            }
            else {

            }
            await this.getallfiledata()

            this.spinner.hide();
            if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {

              if (this.message_flag == true) {

              }

            } else {

            }
            this.toastr.success("Approval Forwarded Successfully!!")
            this.send_to_carto = false
            console.log("Approval Forwarded Successfully!!")
          } else {
            this.spinner.hide();
            console.log(resp['data'])
            this.isResponseReceived = false;
            // this.toastr.errorToastr(resp['data'])
          }
        } else {
          this.isResponseReceived = false;
          this.spinner.hide();
        }
      }
      else {
        this.allTaskArr = []
        let length = resp1.data.length
        this.allTaskArr = resp1.data[length - 1]
        this.spinner.show()
        if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
          var obb: any = new Object();
          if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
            obb['user_id'] = -1
            if (this.allTaskArr['party_id'] == null || this.allTaskArr['party_id'] == undefined) {
              Swal.fire("Error", "Please Map Verdor with Work..!", 'error');
              return
            }
            obb['vendor_id'] = this.allTaskArr['party_id']
          } else {
            obb['user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
          }
          if (obb["user_id"] == -1) {
            let userData: any = {};
            userData['b_acct_id'] = this.b_acct_id;
            userData['user_id'] = obb["vendor_id"];
            let venderInfo = await this.mainserviceEmb.getVenderName(JSON.stringify(obb));
            if (venderInfo["error"] == false) {
              obb['user_name'] = venderInfo["data"]['party_leagal_name']
            }
          } else {
            for (let i = 0; i < this.ApprovalUserService.workuser.length; i++) {
              if (this.ApprovalUserService.workuser[i]['user_id'] == obb["user_id"]) {
                let h = this.ApprovalUserService.workuser[i]['desc'].split("-");
                obb['user_name'] = h[1];
              }
            }
          }


          obb['doc_local_no'] = this.allTaskArr['doc_local_no']
          obb['doc_desc'] = this.allTaskArr['doc_desc']
          obb['node_cd'] = this.allTaskArr['node_cd']

          // if (this.selectedLang == 'Hindi') {
          //   obb['language'] = 'Hindi'
          // } else {
          //   obb['language'] = 'English'
          // }

          obb['b_acct_id'] = this.ebillUser.b_acct_id
          obb['forwarded_by'] = this.ebillUser.user_id
          obb['forward_msg'] = this.remark_note
          obb['remark'] = ""
          obb['status'] = 'PENDING'
          obb['doc_type'] = this.allTaskArr['doc_type']//'EBILL'
          // obb['doc_local_no'] = this.tender_apprdata['doc_local_no']
          // obb['doc_desc'] = this.tender_apprdata['doc_desc']
          obb['undertaking'] = this.allTaskArr['undertaking']
          obb['module_cd'] = this.allTaskArr['module_cd'] //'EMB'
          // obb['node_cd'] = this.tender_apprdata['node_cd']
          if (this.ApprovalUserService.vendorflag == true) {
            obb['level'] = this.allTaskArr['level']
            obb['branch'] = this.allTaskArr['branch']
          }
          else {
            obb['role_cd'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']
            obb['level'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['level']
            obb['branch'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['branch']
          }

          obb['field_value'] = this.allTaskArr['field_value']
          var resp = await this.mainserviceEmb.insertTask(obb)

          if (resp['error'] == false) {
            await this.aftersentpendingapproval()
            if (this.clerk_flag == true) {


              await this.ChangeStatus(this.salBill_apprdata['file_id'], status, obb)
            } else if (this.eng_Dept_flag == true) {

              await this.changedeptstatus(this.allTaskArr['doc_local_no'], status, obb)

            }
            await this.getallfiledata()

            this.spinner.hide();
            if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {

              if (this.message_flag == true) {

              }

            } else {

            }
            this.toastr.success("Approval Forwarded Successfully!!")
            console.log("Approval Forwarded Successfully!!")
          } else {
            this.spinner.hide();
            console.log(resp['data'])
            this.isResponseReceived = false;
            // this.toastr.errorToastr(resp['data'])
          }
        } else {
          this.isResponseReceived = false;
          this.spinner.hide();
          //   }
        }
      }



    }
  }

  async pendingapproval() {
    let d_type;
    let d_status
    if(this.send_to_carto){
      d_type = 'CARTOGRAPHER';
      d_status = 'ASSINGED_CARTOGRAPHER'
    }else{
      d_type = 'CTP'
      d_status = 'ASSINGED_CTP'
    }
    this.spinner.show()
    if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
      let obb: any = new Object();
      if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
      } else {
        obb['user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
        obb['user_name'] = this.ApprovalUserService.userObj[this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']]
      }

      console.log(this.forwarded_user_id)
      obb['b_acct_id'] = this.ebillUser.b_acct_id
      obb['forwarded_by'] = this.ebillUser.user_id
      obb['forward_msg'] = this.appr_remark
      obb['remark'] = this.appr_remark


      obb['status'] = 'PENDING'
      if (this.clerk_flag == true) {

        obb['doc_type'] = d_type
        // status = 'ASSINGED_CTP'
      } else if (this.eng_Dept_flag == true) {
        // obb['doc_type'] = 'ENGINEERING'
        obb['doc_type'] = this.show_Data_obj['doc_type']
        // status = 'ASSINGED_AE'
        this.salBill_apprdata = this.alltabledata
        // obb['status'] = 'APPROVED'
      }
      obb['doc_local_no'] = this.salBill_apprdata['file_id']
      obb['doc_desc'] = `${this.salBill_apprdata['party_name']} 's  File Number ${this.salBill_apprdata['file_id']} Is Assigned to ${d_type}`
      obb['module_cd'] = 'NOC'
      obb['node_cd'] = this.salBill_apprdata['node_cd']
      obb['undertaking'] = JSON.stringify([])
      if (this.ApprovalUserService.vendorflag == true) {
        obb['level'] = this.salBill_apprdata['level']
        obb['branch'] = this.salBill_apprdata['branch']
      }
      else {
        obb['role_cd'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']
        obb['level'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['level']
        obb['branch'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['branch']
      }
      obb['field_value'] = 0
      // var resp = await this.portalmainservice.updatetask(obb)
      let resp = await this.mainserviceEmb.insertTask(obb)
      if (resp['error'] == false) {

        this.spinner.hide();
      } else {
        this.spinner.hide();
      }
    } else {
      this.spinner.hide();
    }
  }

  async ChangeStatus(id: any, status: any, obb: any) {
    let data = new FormData()
    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id;
    obj['status'] = status;
    obj['file_id'] = id
    obj["user_id"] = this.ebillUser.user_id
    obj["department"] = obb["doc_type"]
    obj["node_cd"] = obb["node_cd"]
    obj['role_cd'] = obj['role_cd']
    obj['role_user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
    obj["forwared_by"] = this.role
    obj["description"] = this.show_Data_obj["description"]
    obj["supportive_doc"] = this.NocObj['supportive_doc']
    obj['description'] = this.remark_note
    obj["lang"] = this.editorService.language
    obj["supportive_doc"] = this.NocObj['supportive_doc']
    data.append('data', JSON.stringify(obj))
    console.log(obj);

    this.spinner.show();
    let resp = await this.clerknocservice.changefilestatus(obj)
    // let resp = await this.clerknocservice.changedeptstatus(data)

    if (resp['error'] == false) {
      this.spinner.hide();
      console.log('Successfully Chaged to ' + status)
      await this.getallfiledata()
    }
    else {
      this.spinner.hide();
      this.toastr.error(resp['data']);
    }
  }

  async getallfiledata() {
    let obj: any = new Object()
    obj["b_acct_id"] = this.b_acct_id

    let resp = await this.clerknocservice.getallclerkfiledata(JSON.stringify(obj))
    //console.log(resp);
    if (resp["error"] == false) {
      this.all_data_arr = []
      this.all_data_arr = resp.data;

      //console.log(this.NocObj);
      let j = 1
      for (let i = 0; i < this.all_data_arr.length; i++) {
        this.all_data_arr[i]['new_index'] = j
        j = j + 1
      }
    }
    else {
      Swal.fire("Error", "Server Side Error", 'error')
    }
    console.log(this.all_data_arr);
    let without_reject_data: any = []
    let rejcted_Data: any = []
    this.all_data_arr = this.all_data_arr.filter((item: any) => {

      if (item.life_cycle_status != 'REJECTED') {
        without_reject_data.push(item)
      } else {
        rejcted_Data.push(item)

      }
    })
    console.log(without_reject_data, rejcted_Data);


    this.datasource = new MatTableDataSource(without_reject_data)
    this.datasource.paginator = this.paginator;
    this.datasource.sort = this.sort;

    

  }

  async changedeptstatus(id: any, status: any, obb: any) {
    let data = new FormData()
    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id;
    obj['status'] = status;
    obj['file_id'] = id
    obj["user_id"] = this.ebillUser.user_id
    obj["department"] = obb["doc_type"]
    obj["node_cd"] = obb["node_cd"]
    // obj['role_cd'] = obb['role_cd']
    if (this.ApprovalUserService.rolebyid.length > 0) {

      if (this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']) {

        obj['role_cd'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']
      }
      if (this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']) {

        obj['role_user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
      }
    }
    obj["forwared_by"] = this.role
    obj["description"] = this.show_Data_obj["description"]
    obj["supportive_doc"] = this.NocObj['supportive_doc']
    obj['description'] = this.remark_note
    obj["lang"] = this.editorService.language
    obj["supportive_doc"] = this.NocObj['supportive_doc']
    obj["life_cycle_status"] = this.status
    if (this.selectedFile.length > 0) {
      for (let i = 0; i < this.selectedFile.length; i++) {

        data.append('file', this.selectedFile[i])
      }

    }
    if(obb['last_level_user']){

      obj['last_level_user'] = obb['last_level_user']
    }else{
      obj['last_level_user'] = null

    }

    data.append('data', JSON.stringify(obj))
    console.log(obj);

    this.spinner.show();
    // let resp = await this.clerknocservice.changefilestatus(obj)
    let resp = await this.clerknocservice.changedeptstatus(data)

    if (resp['error'] == false) {
      this.spinner.hide();
      console.log('Successfully Chaged to ' + status)
      Swal.fire('Success', "Successfully Approved", 'success')
      this.list_flag = true;
      // await this.filedatasendbyctp();
    }
    else {
      this.spinner.hide();

      this.toastr.error(resp['data']);
    }
  }
  async aftersentpendingapproval() {
    this.spinner.show()
    var obb: any = new Object();
    obb['b_acct_id'] = this.ebillUser.b_acct_id
    obb['remark'] = this.remark_note //this.appr_remark
    obb['status'] = 'APPROVED'
    obb['language'] = this.editorService.language
    obb['id'] = this.allTaskArr['id']
    obb['doc_type'] = this.allTaskArr['doc_type']
    obb['undertaking'] = this.allTaskArr['undertaking'] ? this.allTaskArr['undertaking'] : JSON.stringify([])


    if (this.editorService.language == 'Hindi') {
      obb['language'] = 'Hindi'
    } else {
      obb['language'] = 'English'
    }


    var resp = await this.portalmainservice.updatetask(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');
    }
  }


  undertakings: any = []
  async lastlevelappr() {

    await this.getallworklowidbyuser(this.alltabledata)
    let result = await this.getAllTaskOflastlevelappproval(this.alltabledata['file_id'])
    console.log(result)
    this.spinner.show()
    var obb: any = new Object();
    let status;
    if (this.eng_Dept_flag == true && result == 1) {
      // obb['doc_type'] = 'ENGINEERING'
      obb['doc_type'] = this.show_Data_obj['doc_type']
      obb['last_level_user'] = 'last_level_user'
      status = 'LAST_LEVEL_APPROVED'
      this.salBill_apprdata = this.alltabledata

    }
    else if(this.eng_Dept_flag == true){
      obb['doc_type'] = this.show_Data_obj['doc_type']
      status = 'LAST_LEVEL_APPROVED'

      this.salBill_apprdata = this.alltabledata
    }

    obb['b_acct_id'] = this.ebillUser.b_acct_id
    // obb['remark'] = this.remark_note //this.appr_remark
    obb['remark'] = this.appr_remark

    obb['status'] = 'APPROVED'
    obb['language'] = this.editorService.language
    obb['id'] = this.workflowid
    obb['doc_local_no'] = this.salBill_apprdata['file_id']
    obb['undertaking'] = JSON.stringify([])

    // if (this.editorService.language == 'Hindi') {
    //   obb['language'] = 'Hindi'
    // } else {
    //   obb['language'] = 'English'
    // }


    var resp = await this.portalmainservice.updatetask(obb)
    if (resp['error'] == false) {
      if (this.eng_Dept_flag == true) {
        await this.changedeptstatus(this.salBill_apprdata['file_id'], status, obb)

        // await this.changelastdeptstatus(this.salBill_apprdata['file_id'], status, obb)

      }
      this.spinner.hide();
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');
    }

  }
  workflowid: any = []

  async getallworklowidbyuser(item: any) {

    let obj: any = {}
    obj["b_acct_id"] = this.ebillUser.b_acct_id
    obj["role"] = item.role
    obj["doc_type"] = item.doc_type
    obj["doc_local_no"] = item.file_id
    obj["module_cd"] = 'NOC'
    let resp = await this.clerknocservice.getworkflowid(JSON.stringify(obj))
    console.log(resp)
    if (resp["error"] == false) {
      this.workflowid = []
      this.workflowid = resp['data'][0]['id']
    }
  }
  lastlevel_data: any = []
  async getAllTaskOflastlevelappproval(file_id: any) {
    let obj: any = {}
    obj["b_acct_id"] = this.b_acct_id
    obj['doc_type'] = this.lastlevel_data.map((item: any) => item.doc_type)
    obj['role_cd'] = this.lastlevel_data.map((item: any) => item.role_cd)
    obj['status'] = 'PENDING'
    obj['module_cd'] = 'NOC'
    obj['doc_local_no'] = file_id
    let resp = await this.clerknocservice.getlastlevependingdata(JSON.stringify(obj))
    console.log(resp)
    return resp.data.length
  }

  role_cdArr: any = []
  async getallworkflowuser() {
    let obj: any = {}
    obj["b_acct_id"] = this.b_acct_id
    obj["doc_type"] = ['TAX', 'PROPERTY', 'ENGINEERING']
    obj["module_cd"] = 'NOC'
    obj["role"] = this.role
    obj["status"] = 'ACTIVE'

    let resp = await this.clerknocservice.getallworkflowuser(JSON.stringify(obj))
    console.log(resp)
    if (resp["error"] == false) {
      this.role_cdArr = []
      this.AllWorkFlow_Data = []
      this.AllWorkFlow_Data = resp.data
      this.role_cdArr = resp.data.map((item: { role_cd: any; }) => item.role_cd)
      console.log(this.AllWorkFlow_Data);
      this.lastlevel_data = []
      this.lastlevel_data = await this.getLastLevelRoles(resp.data);
      console.log(this.lastlevel_data);

    }
  }
  async getLastLevelRoles(data: any) {
    return data.reduce((acc: any, item: any) => {
      const existing = acc.find((d: any) => d.doc_type === item.doc_type);
      if (!existing || existing.level < item.level) {
        acc = acc.filter((d: any) => d.doc_type !== item.doc_type);
        acc.push(item);
      }
      return acc;
    }, []);
  };
}
